import $ from 'jquery';
import 'magnific-popup';
import './Language/magnific-popup'

(function () {
    var lightboxes = $('a.lightbox');
    if (lightboxes.length === 0) {
        return;
    }

    lightboxes.magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            easing: 'ease-in-out'
        }
    });
}());

(function () {
    var lightboxes = $('.main-content a.lightbox');
    if (lightboxes.length === 0) {
        return;
    }

    lightboxes.magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: false,
            easing: 'ease-in-out'
        },
        callbacks: {
            open: function() {
                $(this.container).addClass('mfp-light-background');
            },
        }
    });
}());
